package com.hyperether.goodjob.database

import kotlin.Long
import kotlin.String

public data class Workspace(
  public val id: Long,
  public val _id: String?,
  public val name: String?,
  public val type: String?,
  public val user_id: String?,
  public val plan: String?,
  public val workspaceType: String?,
  public val lastAccessed: String?,
)
